import * as React from 'react';
import {useState} from 'react';
import {useForm} from 'react-hook-form';

import ILocation from '../../../_typescript/interfaces/ILocation';
import AnchorScroll from '../../../components/AnchorScroll/AnchorScroll';
import PasswordInput from '../../../components/Form/PasswordInput/PasswordInput';
import SubmitButton from '../../../components/Form/SubmitButton/SubmitButton';
import TextInput from '../../../components/Form/TextInput/TextInput';
import Layout from '../../../components/Layout/Layout';
import Link from '../../../components/Link/Link';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import {apiPostUnauthenticated} from '../../../project_api/api';
// @ts-ignore
import * as profileStyles from '../profile.module.css';

const STATUS_NOT_SUBMITTED = 'STATUS_NOT_SUBMITTED';
const STATUS_IS_SUBMITTING = 'STATUS_IS_SUBMITTING';
const STATUS_SENT = 'STATUS_SENT';
const STATUS_ERROR = 'STATUS_ERROR';

const onSubmit = async (data: {[key: string]: any}, setStatus: any) => {
    for (const fieldName of Object.keys(data)) {
        const value = data[fieldName];
        if ('object' === typeof value) {
            //handle checkboxes
            data[fieldName] = value.value;
        }
    }

    data.device_name = 'browser';
    data.token = new URLSearchParams(window.location.search).get('token');

    const result = await apiPostUnauthenticated('/profile/password/update', data);
    if (result.success) {
        if (result.success) {
            setStatus(STATUS_SENT);
        } else {
            setStatus(STATUS_ERROR);
        }
    } else {
        setStatus(STATUS_ERROR);
    }
    // reset();
};

interface IPasswordResetPage {
    location: ILocation;
}

const PasswordResetPage = ({location,}: IPasswordResetPage) => {
    const [shouldValidate, setShouldValidate,] = useState(false);
    const [status, setStatus,] = useState(STATUS_NOT_SUBMITTED);

    const {formState, register, handleSubmit,} = useForm({
        reValidateMode: 'onChange',
        defaultValues: {},
    });

    if (STATUS_SENT === status) {
        return (
            <AnchorScroll>
                <Layout location={location}>
                    <div className="grid-2--mobile grid-8--tablet grid-12--desktop">
                        <section>
                            <div className={`grid-8--desktop grid-offset-2--desktop ${profileStyles.form}`}>
                                <p>
                                    Ihr Passwort wurde erfolgreich geändert. Bitte{' '}
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            window.dispatchEvent(new Event('callwey-open-login-overlay'))
                                        }}
                                        style={{textDecoration: 'underline'}}
                                    >
                                        melden Sie sich erneut an.
                                    </a>
                                </p>
                            </div>
                        </section>
                    </div>
                </Layout>
            </AnchorScroll>
        );
    }

    return (
        <AnchorScroll>
            <Layout location={location}>
                <div className="grid-2--mobile grid-8--tablet grid-12--desktop">
                    <section>
                        {status === STATUS_ERROR && (
                            <div className={`grid-8--desktop grid-offset-2--desktop ${profileStyles.form}`}>
                                <h3
                                    className={`
                                        grid-6--tablet
                                        grid-6--desktop
                                    `}
                                >
                                    Ein Fehler ist aufgetreten
                                </h3>
                            </div>
                        )}
                        {status === STATUS_IS_SUBMITTING && (
                            <div className={`grid-8--desktop grid-offset-2--desktop ${profileStyles.form}`}>
                                <LoadingSpinner />
                            </div>
                        )}
                        {status === STATUS_NOT_SUBMITTED && (
                            <form
                                className={`grid-8--desktop grid-offset-2--desktop ${profileStyles.form}`}
                                onSubmit={handleSubmit((data) => {
                                    onSubmit(data, setStatus);
                                    setStatus(STATUS_IS_SUBMITTING);
                                })}
                            >
                                <TextInput
                                    label={'E-Mail'}
                                    register={register}
                                    formState={formState}
                                    name={'email'}
                                    id={`email${Date.now()}`}
                                    placeholder={'Ihre E-Mail Adresse'}
                                    shouldValidate={shouldValidate}
                                    validationRules={{
                                        required: {
                                            value: true,
                                            message: 'Bitte geben Sie Ihre E-Mail-Adresse an',
                                        },
                                    }}
                                />

                                <PasswordInput
                                    label={'Passwort'}
                                    register={register}
                                    formState={formState}
                                    name={'password'}
                                    id={`password${Date.now()}`}
                                    placeholder={'Neues Passwort'}
                                    shouldValidate={shouldValidate}
                                    validationRules={{
                                        required: {
                                            value: true,
                                            message: 'Bitte geben Sie ein Passwort an',
                                        },
                                        minLength: {
                                            value: 12,
                                            message: 'Please enter at least 6 characters',
                                        },
                                    }}
                                />

                                <PasswordInput
                                    label={'Passwort wiederholen'}
                                    register={register}
                                    formState={formState}
                                    name={'password_confirmation'}
                                    id={`password_confirmation${Date.now()}`}
                                    placeholder={'Wiederholen Sie Ihr Passwort'}
                                    shouldValidate={shouldValidate}
                                    validationRules={{
                                        required: {
                                            value: true,
                                            message: 'Bitte geben Sie ein Passwort an',
                                        },
                                        // 'validate': (value) => {
                                        //     trigger('password_repeat');
                                        //     return true;
                                        // },
                                    }}
                                />

                                <div className="flex">
                                    <SubmitButton
                                        onMouseDown={() => {
                                            setShouldValidate(true);
                                        }}
                                        className={profileStyles.submit}
                                        label="Passwort zurücksetzen"
                                    />
                                </div>
                            </form>
                        )}
                    </section>
                </div>
            </Layout>
        </AnchorScroll>
    );
};

export default PasswordResetPage;
